"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useTransition } from "react";

export interface Tab {
    name: string;
    id: any;
    active?: boolean;
    href: string;
}

export const Tabs = ({ tabs }: { tabs: Tab[] }) => {
    const [isPending, startTransition] = useTransition();
    const router = useRouter();
    return (
        <div className="overflow-x-auto">
            <ul className="flex gap-6 m-4 border-b-2 border-lightGray w-fit md:w-auto">
                {tabs.map((tab) => (
                    <li
                        className={`whitespace-nowrap border-b-2 ${tab.active ? "border-cherryRed font-bold" : "border-transparent font-normal"} relative top-0.5 ${isPending ? "text-gray" : ""}`}
                        key={tab.name}
                    >
                        <Link
                            href={tab.href}
                            className={`block py-2 no-underline `}
                            onClick={() =>
                                startTransition(() => {
                                    router.push(tab.href);
                                })
                            }
                        >
                            {tab.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};
